<script lang="ts" module>
  import type { Snippet } from "svelte";
  import MinicartProgressbar from "./minicart-progressbar.svelte";
  import { css } from "@agapi/ui/panda/css";

  export interface MiniCartProps {
    /** A Svelte snippet containing the checklist items. */
    children?: Snippet;
    progress: number;
  }
</script>

<script lang="ts">
  const { children, progress }: MiniCartProps = $props();

  const freeShippingProgressStyles = css({
    display: "flex",
    flexDir: "column",
    height: "68px",
    gap: "2",
    p: "tight",
    bg: "surface.primary.vibrant.background",
    rounded: "4",
    mt: "-50px",
  });
</script>

<div class={freeShippingProgressStyles}>
  <MinicartProgressbar progress={progress} />
  {@render children?.()}
</div>
